import { G } from "../../constants/theme";

export default function HLCard({ icon, title, desc }) {
  return (
    <div
      style={{
        background: G.card,
        padding: "30px 28px",
        display: "flex",
        gap: 16,
        alignItems: "flex-start",
        borderBottom: `1px solid ${G.border}`,
      }}
    >
      <div
        style={{
          width: 34,
          height: 34,
          border: `1px solid ${G.greenDim}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: G.green,
          flexShrink: 0,
          fontSize: 15,
        }}
      >
        {icon}
      </div>
      <div>
        <strong
          style={{
            display: "block",
            fontFamily: "monospace",
            fontSize: 11,
            letterSpacing: 1,
            color: G.white,
            marginBottom: 5,
            textTransform: "uppercase",
          }}
        >
          {title}
        </strong>
        <span style={{ fontSize: 13, color: G.muted, lineHeight: 1.65 }}>{desc}</span>
      </div>
    </div>
  );
}
